import { motion } from 'framer-motion'

export default function SiteLoader() {
  return (
    <div className="fixed inset-0 z-[100] bg-white flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.98 }}
        transition={{ duration: 0.25 }}
        className="text-center"
      >
        <div className="mx-auto w-14 h-14 rounded-2xl border border-brand-primary/20 bg-brand-primary/5 flex items-center justify-center shadow-sm">
          <div className="text-brand-primary font-extrabold">RM</div>
        </div>
        <div className="mt-3 text-sm font-semibold text-slate-700">Loading…</div>
      </motion.div>
    </div>
  )
}

